<script setup lang="ts">
import { Multiselect } from 'vue-multiselect';
import TopicsService from '#layers/prawopl/app/pages/cms/modules/wk-topics/_runtime/services/TopicsService';

defineOptions({
    name: 'WkSectionTopics',
    components: {
        multiselect: Multiselect
    }
});

const emit = defineEmits<{
    (e: 'update:modelValue', value: Option<string>[]): void;
}>();

const props = defineProps<{
    modelValue: string[];
}>();

const { $alert } = useAlerts();
const { $log } = useLogging();

const options = ref<Option<string>[]>([]);
const selectedOptions = ref<Option<string>[]>([]);

const topics = computed({
    get(): Option<string>[]
    {
        return selectedOptions.value;
    },
    set(value: Option<string>[])
    {
        triggerModel(value);
    }
});

function triggerModel(value: Option<string>[]): void
{
    emit('update:modelValue', value.map(p => p.value));
}

const onSearchChanged = useDebounceFn(async (topic: string): Promise<void> =>
{
    try
    {
        if (topic && topic.length > 0 && topic.length <= 100)
        {
            options.value = (await TopicsService.getAutocompleteModel(topic)).map((p: any) => ({
                text: p.name,
                value: p.name
            }));
        }
        else
        {
            options.value = (await TopicsService.getAll()).map((p: any) => ({
                text: p.name,
                value: p.name
            }));
        }
    }
    catch (ex)
    {
        handleException($log, ex, {
            400: (ex: any) => $alert.warning(ex.message)
        });
    }
}, 500);

watch(() => props.modelValue, async () =>
{
    await loadSelectedTopics();
}, { deep: true });

async function loadSelectedTopics(): Promise<void>
{
    if (props.modelValue && props.modelValue.length > 0)
    {
        selectedOptions.value = props.modelValue.map((item: string) => ({
            text: item,
            value: item
        }));
    }
    else
    {
        selectedOptions.value = [];
    }
}

async function loadAllOptions(): Promise<void>
{
    try
    {
        options.value = (await TopicsService.getAll()).map((p: any) => ({
            text: p.name,
            value: p.name
        }));
    }
    catch (ex)
    {
        options.value = [];
        handleException($log, ex, {
            400: (ex: any) => $alert.warning(ex.message)
        });
    }
}
onMounted(async (): Promise<void> =>
{
    await loadAllOptions();
});
</script>

<template>
    <Multiselect
        v-model="topics"
        label="text"
        track-by="value"
        :options="options"
        :multiple="true"
        :placeholder="$t('[[[Wyszukaj etykietę tematyczną]]]')"
        :select-label="$t('[[[Naciśnij enter aby wybrać]]]')"
        :selected-label="$t('[[[Wybrano]]]')"
        :deselect-label="$t('[[[Naciśnij enter aby usunąć]]]')"
        :select-group-label="''"
        :deselect-group-label="''"
        @search-change="onSearchChanged"
    >
        <template #noOptions>
            {{ $t('[[[Lista jest pusta]]]') }}
        </template>
        <template #noResult>
            {{ $t('[[[Nie znaleziono żadnych wyników.]]]') }}
        </template>
    </Multiselect>
</template>
